import { render, staticRenderFns } from "./music.vue?vue&type=template&id=36ab696a&scoped=true&"
import script from "./music.vue?vue&type=script&lang=js&"
export * from "./music.vue?vue&type=script&lang=js&"
import style0 from "./music.vue?vue&type=style&index=0&id=36ab696a&prod&lang=css&"
import style1 from "./music.vue?vue&type=style&index=1&id=36ab696a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab696a",
  null
  
)

export default component.exports